import { motion } from "framer-motion";
import { MANIFESTO } from "../../data";

export default function Manifesto() {
  return (
    <section id="approach" data-testid="manifesto-section" className="py-24 md:py-36 border-t border-[#27272a] bg-[#0a0a0a]">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="mb-16">
          <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#ff4500]">/ 03 — Why Qualiz</span>
          <h2 className="mt-5 font-heading font-black uppercase tracking-tighter leading-none text-4xl md:text-6xl text-[#f4f4f5] max-w-3xl">
            Timely and accurate test results.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-0">
          <div className="md:col-span-3">
            <div className="md:sticky md:top-28 mb-10 md:mb-0">
              <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#8e8e93]">
                Our principles
              </span>
              <div className="mt-4 w-16 h-px bg-[#ff4500]" />
            </div>
          </div>

          <div className="md:col-span-9 divide-y divide-[#27272a] border-t border-[#27272a]">
            {MANIFESTO.map((m, i) => (
              <motion.div
                key={m.num}
                data-testid={`manifesto-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                className="group py-10 md:py-14 flex flex-col md:flex-row gap-6 md:gap-12"
              >
                <span className="font-mono text-sm text-[#ff4500] md:pt-3 shrink-0">{m.num}</span>
                <div>
                  <h3 className="font-heading font-bold uppercase tracking-tight text-2xl md:text-4xl text-[#f4f4f5] group-hover:translate-x-2 transition-transform duration-500">
                    {m.title}
                  </h3>
                  <p className="mt-4 text-[#8e8e93] text-base md:text-lg font-light leading-relaxed max-w-2xl">
                    {m.body}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
